<template>
  <div>
    <div class="bigbutton buttonsizing" style="display:flex; flex-wrap: nowrap;">
      <span style="overflow:hidden; flex: 2 1 auto; text-align: left;"><span style="margin-left:30px;">{{name}}</span></span>
      <span style="flex: 0 1 auto; margin-right: 20px;" class="icons">
        <span class="cursed" v-on:click="$emit('play')">
          <svg alt="Play in browser" width="28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path fill="currentColor" d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z" />
          </svg>
        </span>
        <span class="cursed" v-on:click="$emit('open-vlc')">
          <svg alt="Open in VLC" width="28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z" />
          </svg>
        </span>
        <span class="cursed" v-if="loggedIn" v-on:click="$emit('moveto')">
          <svg width="28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path fill="currentColor" d="M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z" />
          </svg>
        </span>
      </span>
    </div>
    <div class="buttonsizing info smaller">
        <span>{{name}}</span><span v-if="artist && artist.length>0 || title && title.length>0">: </span> <span v-if="artist && artist.length>0">{{artist}} - </span>{{title}} <span v-if="listeners && listeners !== '0'"> 🎧 {{listeners}}</span>
    </div>
  </div>
</template><script lang="ts">

  export default {
    name: 'Channel',
    components: {
    },
    props: {
      url: String,
      name: String,
      title: String,
      artist: String,
      listeners: Number,
      loggedIn: Boolean
    }
  }
</script>
<style type="text/css" scoped>
  .icons span {
    margin-top: 2px;
    margin-right: 4px;
  }
</style>